<template>
  <div class="news-file" :style="{ height: height + 'px' }">
    <div class="news-file__media" @contextmenu.prevent>
      <img v-if="image && url" :src="url" :alt="attachment.name" class="news-file__image" draggable="false" />
      <video
        v-else-if="video && url"
        ref="video"
        :src="url"
        class="news-file__video"
        controls
        controlsList="nodownload"
        disablepictureinpicture
      ></video>
      <v-progress-circular v-else-if="image && loading" indeterminate color="primary"></v-progress-circular>
      <v-icon v-else size="72" :color="icon_color">{{ icon }}</v-icon>
    </div>

    <div class="news-file__row">
      <v-icon :color="icon_color">{{ icon }}</v-icon>
      <div class="news-file__info">
        <div class="news-file__name">{{ attachment.name }}</div>
        <div class="news-file__size">{{ viewable ? size : "Vista previa no disponible" }}</div>
      </div>
      <div class="news-file__actions">
        <v-btn v-if="video && !url" small text color="primary" :loading="loading" @click="loadPreview">Reproducir</v-btn>
        <v-btn v-if="pdf" small text color="primary" @click="pdf_open = true">Ver</v-btn>
      </div>
    </div>

    <div v-if="attachment.caption" class="news-file__caption">{{ attachment.caption }}</div>

    <NewsPdfViewer v-if="pdf" v-model="pdf_open" :attachment="attachment" />
  </div>
</template>

<script>
import { newsService } from "@/libs/ws/newsService";
import { isImage, isVideo, formatSize } from "./newsModel";
import NewsPdfViewer from "./NewsPdfViewer.vue";

export default {
  name: "NewsAttachment",
  components: { NewsPdfViewer },
  props: {
    attachment: Object,
    // Si es la diapositiva visible del carrusel
    active: Boolean,
    height: Number,
  },
  data() {
    return {
      url: null,
      loading: false,
      pdf_open: false,
    };
  },
  computed: {
    image() {
      return isImage(this.attachment.file_type);
    },
    video() {
      return isVideo(this.attachment.file_type);
    },
    pdf() {
      return this.attachment.file_type == "pdf";
    },
    // Una novedad vieja puede tener un Office o ZIP: esos ya no se sirven
    viewable() {
      return this.pdf || this.image || this.video;
    },
    size() {
      return formatSize(this.attachment.size);
    },
    icon() {
      if (this.pdf) return "mdi-file-pdf-box";
      if (this.image) return "mdi-file-image-outline";
      if (this.video) return "mdi-file-video-outline";
      return "mdi-file-document-outline";
    },
    icon_color() {
      return this.pdf ? "red" : "blue-grey";
    },
  },
  watch: {
    // El carrusel solo oculta las diapositivas: el video seguiría sonando
    active(active) {
      if (!active && this.$refs.video) this.$refs.video.pause();
    },
  },
  mounted() {
    // El carrusel monta cada diapositiva al mostrarla: las imagenes se piden recien ahi. Los videos, al reproducirlos
    if (this.image) this.loadPreview();
  },
  beforeDestroy() {
    if (this.url) URL.revokeObjectURL(this.url);
  },
  methods: {
    loadPreview() {
      this.loading = true;
      newsService
        .file(this.attachment)
        .then((response) => {
          if (response.status) this.url = URL.createObjectURL(response.blob);
          else this.$toast.error(response.msg, "Error");
        })
        .catch(() => this.$toast.error("No se pudo abrir el archivo.", "Error"))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.news-file {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
}
.news-file__media {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news-file__image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  -webkit-touch-callout: none;
}
.news-file__video {
  display: block;
  width: 100%;
  height: 100%;
  background: #000;
}
.news-file__row {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}
.news-file__info {
  flex: 1;
  min-width: 0;
}
.news-file__name {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  overflow-wrap: anywhere;
}
.news-file__size {
  font-size: 12px;
  color: #64748b;
}
.news-file__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.news-file__caption {
  flex-shrink: 0;
  max-height: 72px;
  overflow-y: auto;
  padding: 10px 12px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  font-size: 14px;
  color: #475569;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
